const wishlistItemTypes = {
    WISHLIST_ITEM_ADD:'WISHLIST_ITEM_ADD',
    WISHLIST_ITEM_GET:'WISHLIST_ITEM_GET',
    WISHLIST_ITEM_SUCCESS:'WISHLIST_ITEM_SUCCESS',
    WISHLIST_ITEM_DELETE:'WISHLIST_ITEM_DELETE',
}
export default wishlistItemTypes;